// npm i react-slick --save
// npm i slick-carousel --save

// https://react-slick.neostack.com/docs/example/responsive
// import React,{useEffect} from 'react'
// import Slider from 'react-slick'
// import 'slick-carousel/slick/slick.css'
// import 'slick-carousel/slick/slick-theme.css'
// import { TestimonialsData } from './data'
// import './testimonials.css'


// const Testimonial = () => {
  

//     var settings = {
//         dots: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         initialSlide: 0,
//         autoplay: true,
//       autoplayTimeout: 1000,
//       autoplayHoverPause: true,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               infinite: true,
//               dots: true
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               initialSlide: 2
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1
//             }
//           }
//         ]
//       };

//   return (
//     <section class="Testimonial-Section container "  id='testimonials'>
// <h1  className="port-head" style={{textAlign:"center",
//       fontSize:"1.9rem",
//       fontWeight:"800",
//       color:"rgb(0,0,0)",
//       margin:"2rem 0"}}>SERVICES</h1><Slider {...settings} >
// {TestimonialsData.map((item) => (

//     <div className="testmonial-card">       

// <div className="testmonial-card-bottom">
// <h6>{item.title}</h6>
// <p >{item.description}</p>
// </div>
// </div>
   
// ))}
// </Slider>


//     </section>
//   )
// }

// export default Testimonial














// import React from 'react';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

// const TestimonialsData = [
//     {
//         id: 1,
//         title: "Web Design",
//         description: "From concept to creation, I specialize in crafting visually stunning and user-friendly website designs that captivate audiences and elevate brands. Let's collaborate to bring your vision to life with innovative design solutions tailored to your unique identity and goals.",
//     },
//     {
//         id: 2,
//         title: "Front-end Development",
//         description: "Transforming designs into interactive and responsive web experiences is my expertise. With a keen eye for detail and proficiency in HTML, CSS, and JavaScript, I develop seamless front-end solutions that deliver exceptional usability and platforms.",
//     },
//     {
//         id: 3,
//         title: "Back-end Development",
//         description: "Powering your website with robust functionality and seamless performance. Leveraging the latest technologies and frameworks, I specialize in building scalable back-end systems, databases, and APIs that drive dynamic content delivery and streamline user experiences.",
//     },
//     {
//         id: 4,
//         title: "E-commerce Solutions",
//         description: "Take your online business to new heights with custom e-commerce solutions tailored to your specific needs. From secure payment gateways to intuitive shopping experiences, I'll help you create a feature-rich online store that maximizes conversions and enhances customer satisfaction.",
//     },
//     {
//         id: 5,
//         title: "Responsive Design",
//         description: "Ensure your website looks and performs flawlessly on every device with responsive design. With a mobile-first approach and attention to detail, I'll optimize your website for all screen sizes, delivering a consistent and engaging experience that keeps visitors coming back for more.",
//     },
//     {
//         id: 6,
//         title: "Custom Solutions",
//         description: "Have a unique idea or specific requirement? I thrive on challenges and love turning innovative concepts into reality. Let's discuss your project goals and explore how we can create a custom solution that sets you apart and drives success in the digital landscape.",
//     }
// ];

// const Testimonials = () => {
//     const sliderSettings = {
//         dots: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         adaptiveHeight: true
//     };

//     // Inline styles
//     const containerStyle = {
//         width: '80%',
//         margin: '0 auto',
//         textAlign: 'center',
//         padding: '20px'
//     };

//     const slideStyle = {
//         padding: '20px',
//         background: '#f9f9f9',
//         border: '1px solid #ddd',
//         borderRadius: '10px',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         margin: '0 10px'
//     };

//     const titleStyle = {
//         marginBottom: '10px',
//         fontSize: '1.5em',
//         color: '#333'
//     };

//     const descriptionStyle = {
//         fontSize: '1em',
//         color: '#666'
//     };

//     const headingStyle = {
//         fontSize: '2em',
//         marginBottom: '20px',
//         color: '#333'
//     };

//     return (
//         <div style={containerStyle}>
//             <h2 style={headingStyle}>Our Services</h2>
//             <Slider {...sliderSettings}>
//                 {TestimonialsData.map((testimonial) => (
//                     <div key={testimonial.id} style={slideStyle}>
//                         <h3 style={titleStyle}>{testimonial.title}</h3>
//                         <p style={descriptionStyle}>{testimonial.description}</p>
//                     </div>
//                 ))}
//             </Slider>
//         </div>
//     );
// };

// export default Testimonials;















// import React from 'react';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import { Card } from 'react-bootstrap';

// const TestimonialsData = [
//     {
//         id: 1,
//         title: "Web Design",
//         description: "From concept to creation, I specialize in crafting visually stunning and user-friendly website designs that captivate audiences and elevate brands. Let's collaborate to bring your vision to life with innovative design solutions tailored to your unique identity and goals.",
//     },
//     {
//         id: 2,
//         title: "Front-end Development",
//         description: "Transforming designs into interactive and responsive web experiences is my expertise. With a keen eye for detail and proficiency in HTML, CSS, and JavaScript, I develop seamless front-end solutions that deliver exceptional usability and platforms.",
//     },
//     {
//         id: 3,
//         title: "Back-end Development",
//         description: "Powering your website with robust functionality and seamless performance. Leveraging the latest technologies and frameworks, I specialize in building scalable back-end systems, databases, and APIs that drive dynamic content delivery and streamline user experiences.",
//     },
//     // {
//     //     id: 4,
//     //     title: "E-commerce Solutions",
//     //     description: "Take your online business to new heights with custom e-commerce solutions tailored to your specific needs. From secure payment gateways to intuitive shopping experiences, I'll help you create a feature-rich online store that maximizes conversions and enhances customer satisfaction.",
//     // },
//     // {
//     //     id: 5,
//     //     title: "Responsive Design",
//     //     description: "Ensure your website looks and performs flawlessly on every device with responsive design. With a mobile-first approach and attention to detail, I'll optimize your website for all screen sizes, delivering a consistent and engaging experience that keeps visitors coming back for more.",
//     // },
//     // {
//     //     id: 6,
//     //     title: "Custom Solutions",
//     //     description: "Have a unique idea or specific requirement? I thrive on challenges and love turning innovative concepts into reality. Let's discuss your project goals and explore how we can create a custom solution that sets you apart and drives success in the digital landscape.",
//     // }
// ];

// const Testimonials = () => {
//     const sliderSettings = {
//         dots: true,
//         infinite: true,
//         speed: 30000,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         adaptiveHeight: true,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     infinite: true,
//                     dots: true
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1
//                 }
//             }
//         ]
//     };

//     // Inline styles for the slider container
//     const containerStyle = {
//         width: '90%',
//         margin: '0 auto',
//         padding: '20px'
//     };

//     // Inline styles for each slide card
//     const cardStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '30px',
//         backgroundColor: '#fff',
//         borderRadius: '10px',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         margin: '0 10px',
//         minHeight: '200px', // Adjust height as needed
//         textAlign: 'center',
//         transition: 'transform 0.3s ease', // Add transition for hover effect
//         cursor: 'pointer' // Indicate the card is interactive
//     };

//     // Add hover effect
//     const cardHoverStyle = {
//         transform: 'scale(1.05)' // Slightly enlarge the card on hover
//     };

//     // Inline styles for the card title
//     const titleStyle = {
//         fontSize: '1.2em',
//         color: '#007bff',  // Blue text color for the title
//         marginBottom: '10px'
//     };

//     // Inline styles for the card description
//     const descriptionStyle = {
//         fontSize: '1em',
//         color: '#666',
//         lineHeight: '1.5em'
//     };

//     // Inline styles for the heading
//     const headingStyle = {
//         fontSize: '2em',
//         marginBottom: '20px',
//         color: '#333',
//         textAlign: 'center'
//     };

//     return (
//         <div style={containerStyle}>
//             <h2 style={headingStyle}>Our Services</h2>
//             <Slider {...sliderSettings}>
//                 {TestimonialsData.map(testimonial => (
//                     <Card
//                         key={testimonial.id} 
//                         style={cardStyle} 
//                         // Inline hover style using onMouseEnter and onMouseLeave
//                         onMouseEnter={(e) => e.currentTarget.style.transform = cardHoverStyle.transform}
//                         onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                     >
//                         <h3 style={titleStyle}>{testimonial.title}</h3>
//                         <p style={descriptionStyle}>{testimonial.description}</p>
//                     </Card>
//                 ))}
//             </Slider>
//         </div>
//     );
// };

// export default Testimonials










import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Card, Col, Container, Row } from 'react-bootstrap';
const TestimonialsData = [
    {
        id: 1,
        title: "Web Design",
        description: "I create visually stunning, user-friendly websites that captivate audiences. Let's bring your vision to life with tailored, innovative designs that elevate your brand.",
    },
    {
        id: 2,
        title: "Front-end Development",
        description: "Transforming designs into interactive, responsive experiences. With expertise in HTML, CSS, and JavaScript, I build seamless, detail-oriented front-end solutions.",
    },
    {
        id: 3,
        title: "Back-end Development",
        description: "I provide robust, scalable back-end solutions, ensuring smooth functionality. Using the latest technologies, I build systems that enhance user experiences.",
    },
    {
        id: 4,
        title: "E-commerce Solutions",
        description: "Boost your online business with custom e-commerce solutions. From secure payment gateways to intuitive shopping,experienced that enhance customer satisfaction.",
    },
    {
        id: 5,
        title: "Responsive Design",
        description: "With a mobile-first approach, I optimize websites for all devices. Responsive design ensures flawless performance and also a seamless experience across all screen sizes.",
    },
    {
        id: 6,
        title: "Custom Solutions",
        description: "Got a unique idea? I thrive on challenges, turning concepts into reality. Let's discuss your goals and create custom solutions tailored to your project sucess.",
    }
];



const Testimonials = () => {
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 3000, // Speed of sliding
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:false,
        autoplaySpeed: 3000,
        centerMode: true, // Disable centering to avoid additional gaps
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

     const cardStyle = {
        width: '95%', // Ensure the card takes full width of the container
        height:"100%",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        // border:"2px solid black",
        backgroundColor: '#fff',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        margin: '0 5px', // Minimize margin to reduce gaps
        minHeight: '200px',
        textAlign: 'center',
        transition: 'transform 0.3s ease',
        cursor: 'pointer'
    };


    // Inline styles for the card title
    const titleStyle = {
        fontSize: '1.2em',
        color: 'var(--secondary)',
        marginBottom: '10px',
        fontWeight:"bold"
    };

    // Inline styles for the card description
    const descriptionStyle = {
        fontSize: '1em',
        color: '#666',
        lineHeight: '1.5em'
    };


    return (
        <Container fluid >
            <h2  className='sec-title'>Services</h2>
            <Slider {...sliderSettings}>
                {TestimonialsData.map(testimonial => (
            <Row style={{height:"25rem"}}>
                   
                    <Col
                    lg={4} md={4} sm={6}
                        key={testimonial.id} 
                        style={cardStyle} 
                      
                        
                    >
                        <h3 style={titleStyle}>{testimonial.title}</h3>
                        <p style={descriptionStyle}>{testimonial.description}</p>
                    </Col>
                    
                </Row>
                ))}
            </Slider>
        </Container>
    );
};

export default Testimonials;
